import {CustomerAddress} from "../interfaces/store-interfaces";
import {DeliveryBillingAddress} from "../interfaces/cart-interfaces";

export const getAddressOneLine = (address: CustomerAddress): string => {
    return `${address.streetNumber} ${address.route}, ${address.postalCode} ${address.locality},  ${address.country}`
}

export const areAddressEquals = (address1: DeliveryBillingAddress, address2: DeliveryBillingAddress): boolean => {
    if (address2 === undefined) {
        return true;
    }
    return JSON.stringify(address1) === JSON.stringify(address2);
}
